import React, { createContext } from "react";
import useSocket from "../hooks/useSocket";

const SocketContext = createContext();

const SocketContextProvider = ({ children }) => {
  const { socket, notifications, setNotifications } = useSocket();

  const clearNotifications = () => setNotifications([]);

  const values = {
    socket,
    notifications,
    clearNotifications
  };

  return (
    <SocketContext.Provider value={values}>{children}</SocketContext.Provider>
  );
};

export { SocketContext, SocketContextProvider };